<script>
    import { onMount } from "svelte";
    import { ValidationError } from "yup";
    import { schema } from "./schema";
    import SuccessGeneric from "./SuccessGeneric.svelte";
    import { client } from "./apiClient";

    export let token;
    export let region = "au";

    const currentYear = new Date().getFullYear();

    let success = false;
    let MobileApp = window.MobileApp || {};

    let card = {
        pan: "",
        expiryMonth: "-1",
        expiryYear: "-1",
        provider: -1,
        banks: [],
        isChecked: false,
    };

    let isLoaderOn = "none";
    //All errors object.
    let errors = {};

    //Extract inner error from yup
    const extractErrors = (err) => {
        return err.inner.reduce((acc, err) => {
            return { ...acc, [err.path]: err.message };
        }, {});
    };

    //Send Form to API
    const handleSubmit = async () => {
        console.table(card);
        const result = await schema
            .validate(card, { abortEarly: false })
            .then(async () => {
                errors = {};
                const cardBody = card.pan + card.expiryMonth + card.expiryYear;

                var result = await client.enroll(card, cardBody, token);

                if (result.ok) {
                    var obj = await result.json();

                    var model = {
                        isSuccess: true,
                        response: {
                            message: obj.status,
                            cardInfo: obj.card,
                        },
                    };

                    if (window.webkit != undefined) {
                        window.webkit.messageHandlers.MobileApp.postMessage(
                            model
                        );
                    } else {
                        CardLinkedServices.sendResponse(JSON.stringify(model));
                    }
                } else {
                    var errorMessage = "";
                    var errorCode = "";

                    if (result.status === 500) {
                        errorMessage = "something went wrong";
                        errorCode = "-500";
                    } else {
                        const errorresp = await result.json();
                        errorMessage = errorresp.errors[0];
                        errorCode = errorresp.code;
                    }

                    var model = {
                        isSuccess: false,
                        errorMessage: errorMessage,
                        errorCode: errorCode,
                    };

                    if (window.webkit != undefined) {
                        window.webkit.messageHandlers.MobileApp.postMessage(
                            model
                        );
                    } else {
                        CardLinkedServices.sendResponse(JSON.stringify(model));
                    }
                }

                isLoaderOn = "none";
            })
            .catch((err) => (errors = extractErrors(err)));

        console.log(errors);
    };

    function pad(d) {
        return d < 10 ? "0" + d.toString() : d.toString();
    }

    onMount(() => {
        client
            .banks(region, token)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    var errorMessage = "something went wrong";
                    var errorCode = "-500";

                    var model = {
                        isSuccess: false,
                        errorMessage: errorMessage,
                        errorCode: errorCode,
                    };

                    if (window.webkit != undefined) {
                        window.webkit.messageHandlers.MobileApp.postMessage(
                            model
                        );
                    } else {
                        CardLinkedServices.sendResponse(JSON.stringify(model));
                    }
                }
            })
            .then((data) => {
                card.banks = data.banks;
            });
    });
</script>

<div
    class="spinner-border"
    role="status"
    style="top: 0; bottom: 0; left: 0; right: 0; position: fixed; margin :auto; display:{isLoaderOn} "
>
    <span class="sr-only">Loading...</span>
</div>

<div class="main">
    <div class="content px-2 content-panel">
        {#if success === false}
                <div
                    class="container d-flex justify-content-center"
                    style="margin-top:0px;"
                >
                    <img
                        style="max-width: 100%; "
                        src="images/HumanForceCard.png"
                        alt="Furthr Card"
                    />
                </div>
                <p class="text-center mt-4 px-3">
                    Securely link your preferred Visa or Mastercard so that our brands understand how much you're valued, rewarding you with cashback each time you make a purchase.
                </p>

            <form
                class="form-group mt-4"
                on:submit|preventDefault={handleSubmit}
            >
                <div class="form-group">
                    <div class="row form-group">
                        <div class="col">
                            <!-- <label for="pan">Card Number</label> -->

                            {#if region === "nz"}
                                <input
                                    type="number"
                                    bind:value={card.pan}
                                    id="pan"
                                    class="form-control"
                                    placeholder="4916 XXXX XXXX XXXX: changed"
                                    maxlength="16"
                                />
                            {:else}
                                <input
                                    type="number"
                                    bind:value={card.pan}
                                    id="pan"
                                    class="form-control"
                                    placeholder="5217 XXXX XXXX XXXX"
                                    maxlength="16"
                                />
                            {/if}
                            <span class="validation-message">
                                {#if errors.pan}{errors.pan}{/if}
                            </span>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col">
                            <!-- <label for="expiryMonth">Expiry Month</label> -->
                            <select
                                class="custom-select"
                                style={card.expiryMonth == "-1"
                                    ? "font-weight:500;"
                                    : "font-weight:normal;"}
                                id="expiryMonth"
                                bind:value={card.expiryMonth}
                            >
                                <option value="-1" style="font-weight: 500;"
                                    >Month</option
                                >
                                {#each Array(12) as _, i}
                                    <option value={pad(i + 1)}
                                        >{pad(i + 1)}</option
                                    >
                                {/each}
                            </select>
                            <span class="validation-message">
                                {#if errors.expiryMonth}{errors.expiryMonth}{/if}
                            </span>
                        </div>
                        <div class="col">
                            <!-- <label for="expiryYear">Expiry Year</label> -->
                            <select
                                class="custom-select"
                                style={card.expiryYear == "-1"
                                    ? "font-weight:500;"
                                    : "font-weight:normal;"}
                                id="expiryMonth"
                                bind:value={card.expiryYear}
                            >
                                <option value="-1" style="font-weight: 500;"
                                    >Year</option
                                >
                                {#each Array(10) as _, i}
                                    <option
                                        value={(currentYear + i)
                                            .toString()
                                            .substr(2, 2)}
                                        >{currentYear + i}</option
                                    >
                                {/each}
                            </select>
                            <span class="validation-message">
                                {#if errors.expiryYear}{errors.expiryYear}{/if}
                            </span>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col">
                            <!-- <label for="inputGroupSelect01">Card Provider</label> -->
                            <select
                                class="custom-select"
                                style={card.provider == "-1"
                                    ? "font-weight:500;"
                                    : "font-weight:normal;"}
                                id="inputGroupSelect01"
                                bind:value={card.provider}
                            >
                                <option value="-1" style="font-weight: 500;"
                                    >Card Provider</option
                                >
                                {#each card.banks as bank}
                                    <option value={bank.id}>{bank.name}</option>
                                {/each}
                            </select>
                            <span class="validation-message">
                                {#if errors.provider}{errors.provider}{/if}
                            </span>
                        </div>
                    </div>
                    <div class="row mb-2 form-group">
                        <div class="col">
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    bind:checked={card.isChecked}
                                    class="form-check-input"
                                    id="exampleCheck1"
                                />
                                {#if region === "nz"}
                                    <p class="form-check-label">
                                        I agree that Humanforce, our partners, card
                                        network (Visa) and participating
                                        merchants may use and share details of
                                        qualifying rewards, using my linked
                                        payment card(s) to earn rewards.
                                    </p>
                                {:else}
                                    <p class="form-check-label">
                                        I agree that Humanforce, our partners, card
                                        networks (Mastercards, Visa & Eftpos)
                                        and participating merchants may use and
                                        share details of qualifying rewards,
                                        using my linked payment card(s) to earn
                                        rewards.
                                    </p>
                                {/if}
                            </div>
                            <span class="validation-message">
                                {#if errors.isChecked}{errors.isChecked}{/if}
                            </span>
                        </div>
                    </div>
                    <div class="container d-flex justify-content-center">
                        <button
                            type="submit"
                            class="btn btn-primary-businessplaza col-12 mt-5"
                            >Link Card
                        </button>
                    </div>
                </div>

                <div class="row mb-4 form-group">
                    <div class="col">
                        <ul class="validation-errors">
                            <li class="validation-message">
                                {#if errors.response}{errors.response}{/if}
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        {:else}
            <SuccessGeneric {region} {network} />
        {/if}
    </div>
</div>

<style>
    body{
        background: #ECF0FC
    }
    .content-panel{
        background: #ECF0FC
    }
    .btnSkipNow {
        border: none;
        cursor: pointer;
        outline: none;
        background-color: #ECF0FC;
        color: #1b3af3;
    }
    .btnSkipNow:hover {
        border: 0px;
        background-color: #ECF0FC;
        color: #1b3af3;
    }
    .main {
        background: #ECF0FC;
        height: 100%;
        font-family: 'Metropolis', sans-serif;
    }
    .main .content .row {
        margin-right: 0;
        margin-left: 0;
        padding: 0 9px;
    }
    .main .content .row .col {
        padding-right: 9px;
        padding-left: 9px;
    }
    .custom-select:focus,
    .form-control:focus {
        box-shadow: 0 0 0 0;
        border-color: #3C479D;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type="number"] {
        -moz-appearance: textfield;
    }
    .custom-select {
        cursor: pointer;
        background-size: 24px 24px !important;
        background-color: #ffffff;
    }
    .custom-select,
    .form-control {
        font-size: 17px;
        height: 50px;
        font-weight: normal;
        outline-color: #e7e7e7;
        border-radius: 10px !important;
    }
    .input-group-prepend {
        display: none;
    }
    .form-group .input-group {
        position: relative;
        margin-bottom: 0 !important;
    }
    .form-group .input-group:before {
        content: "";
        position: absolute;
        top: 1px;
        right: 1px;
        width: 22px;
        height: 38px;
        z-index: 999999999;
        pointer-events: none;
        border-radius: 5px;
        background: #fff
            url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACSSURBVHgBhY+7EYMwEERvTUPOL/GnAXdgmkAZAwyQUAUhJRABiQqgAyoBJD6DxGfYSHf7VisRKXle+qQbrYwjRBoAQ8H86aSs2jNYiOQPUMn8pQdRj2Wfa+MM1t489XCkrBvmtwrhpTY/s8mGhyjL/BDbTXGoQsEyumurCesT7HorRHt4+rRp7Z53gC+lm+a2o0ZuRT0oXlNlJQAAAABJRU5ErkJggg==);
        background-repeat: no-repeat;
        background-position: left center;
        cursor: pointer;
    }
    .form-control::-webkit-input-placeholder {
        color: #231b34;
        font-size: 14px;
        font-weight: 500;
    }
    .form-control:-ms-input-placeholder {
        color: #231b34;
        font-size: 17px;
        font-weight: 500;
    }
    .form-control::placeholder {
        color: #231b34;
        font-size: 17px;
        font-weight: 500;
    }
    label {
        color: #767684;
        font-size: 13px;
        font-weight: normal;
        margin-bottom: 4px;
    }
    .main .content.px-4 {
        padding: 16px 0 !important;
    }
    .form-check-label {
        font-size: 14px;
        color: #adadad;
        font-weight: normal;
    }
    button.btn.btn-primary-businessplaza {
        background: #3C479D;
        border-radius: 10px;
        border: 0;
        width: 100%;
        height: 50px;
        font-size: 15px;
        font-weight: 500;
        padding: 9px 10px;
        -webkit-transition: all 0.5s ease 0s;
        transition: all 0.5s ease 0s;
        color: #fff;
    }
    button.btn.btn-primary-businessplaza:hover {
        background: #3C479D;
        color: #fff;
    }
    button.btn.btn-primary-businessplaza:focus {
        background: #3C479D;
        color: #fff;
    }
    ul.validation-errors {
        padding: 0;
    }
    .validation-message {
        color: red;
        font-size: 13px;
        font-weight: 400;
        list-style-type: none;
        text-align: center;
    }

    .form-check {
        position: relative;
        padding-left: 28px;
    }
    .form-check input {
        position: absolute;
        left: 0;
        margin: 0;
        top: 0;
        z-index: 1;
        width: 18px;
        height: 18px;
        opacity: 0;
        cursor: pointer;
    }
    .form-check-label {
        font-size: 14px;
        color: #97979b;
        font-weight: 400;
    }
    p.form-check-label:before {
        position: absolute;
        top: 0;
        left: 0;
        height: 18px;
        width: 18px;
        background: #fff;
        transition: background 250ms;
        border: 1px solid #cccccc;
        border-radius: 0.125rem;
        content: "";
        pointer-events: none;
    }
    .form-check input:checked ~ .form-check-label:before {
        background: #3C479D;
        border-color: #3C479D;
    }
    p.form-check-label:after {
        position: absolute;
        top: 2px;
        left: 8px;
        transition: background 250ms;
        border-radius: 0.125rem;
        content: "";
        z-index: 99999;
        pointer-events: none;
        width: 0.25rem;
        height: 0.6rem;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transition: background 250ms;
        transform: rotate(45deg);
        display: none;
    }
    .form-check input:checked ~ .form-check-label:after {
        display: block;
    }
</style>
